import { useState, useCallback } from "react";

const STORAGE_KEY = "aiv_migration_banner_dismissed";

export const useMigrationBanner = () => {
  const [visible, setVisible] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) !== "1"
  );

  const dismiss = useCallback(() => {
    sessionStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  }, []);

  return { visible, dismiss };
};
